import React, { useState } from 'react';
import { FiTrash2, FiX } from 'react-icons/fi';
import api from '../../api';
import { extractError } from '../../api/client';
import { toast, confirmDelete, showError } from '../../utils/alert';

export default function BulkActions({ selectedIds, onClear, onDone, deleteType, label }) {
  const [deleting, setDeleting] = useState(false);

  if (!selectedIds || selectedIds.length === 0) return null;

  const handleBulkDelete = async () => {
    const res = await confirmDelete(`${selectedIds.length} ${label || 'items'}`);
    if (!res.isConfirmed) return;

    setDeleting(true);
    try {
      await api.bulkDelete({ type: deleteType, ids: selectedIds });
      toast('success', '', `${selectedIds.length} ${label || 'items'} deleted`);
      onClear();
      if (onDone) onDone();
    } catch (err) {
      showError('Failed to delete', extractError(err));
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 12, padding: '10px 16px',
      backgroundColor: 'var(--primary-bg, #eff6ff)', border: '1px solid var(--primary, #3b82f6)',
      borderRadius: 8, marginBottom: 16,
    }}>
      <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--primary, #3b82f6)' }}>
        {selectedIds.length} selected
      </span>
      <button className="btn btn-danger btn-sm" onClick={handleBulkDelete} disabled={deleting}>
        <FiTrash2 /> {deleting ? 'Deleting...' : 'Delete Selected'}
      </button>
      <button className="btn-icon" onClick={onClear} title="Clear selection">
        <FiX />
      </button>
    </div>
  );
}
